var wlmLocalData = [];
var filteredHandles = [];

function wlmMonsterCart() {
  const monsterCart = document.getElementById('monster-upsell-cart');
  if (monsterCart) {
    console.log('WLM & Monster Cart integration running.');
    let fbtItems = document.querySelectorAll('.mu-fbt-item');
    fbtItems.forEach((item) => {
      let referenceItem = { element: item };
      let handle = item.querySelector('.mu-fbt-item-title a');
      if (handle) {
        handle = handle.href.split('/products/')[1];
        referenceItem.handle = handle;
        filteredHandles.push(referenceItem);
      }
    })
    checkWlmApi(filteredHandles);
  }
}

function hideProducts(handles) {
  if (handles && handles.length) {
    handles.forEach((item) => {
      wlmLocalData = wlmLocalData.filter(value => Object.keys(value).length !== 0);
      if (!wlmLocalData.find((product) => product.handle == item.handle)) {
        //console.log('Element to remove:', item.element);
        item.element.remove();
      }
    })
  }
}

function checkWlmApi(filteredHandles) {
  const maxHandleLimit = 20;
  let from = 0;
  let left = filteredHandles.length;
  let to = maxHandleLimit;
  
  do {
    let paged = filteredHandles.map(item => item.handle).slice(from, to);
    const url = `/search?view=wlm-api&handle=${paged.join(",")}`;
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        var json = JSON.parse(this.responseText);
        wlmLocalData = [].concat(wlmLocalData,json.products);
        //console.log('WLM API Response:', json);
        hideProducts(filteredHandles);
      }
    }
    xhttp.open("GET", url, false);
    xhttp.send();
  
    from = to;
    to += maxHandleLimit;
    left -= maxHandleLimit;
  } while (left >= 0);
}

window.addToCartCallBack = function(item, items) {
  setTimeout(() => {
    wlmMonsterCart();
  }, 500)
};

document.addEventListener("cart:updated", ({detail: { items }}) => {
  setTimeout(() => {
    wlmMonsterCart();
  }, 500)
});

const intervalId = setInterval(() => {
  const monsterCart = document.querySelector('.mu-frequently-container');
  if (monsterCart) {
    hideProducts(filteredHandles);
  }
}, 50);